import { render, staticRenderFns } from "./SelectContactBody.vue?vue&type=template&id=faf610b4&scoped=true&lang=pug"
import script from "./SelectContactBody.vue?vue&type=script&lang=js"
export * from "./SelectContactBody.vue?vue&type=script&lang=js"
import style0 from "./SelectContactBody.vue?vue&type=style&index=0&id=faf610b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf610b4",
  null
  
)

export default component.exports